module.exports = __webpack_public_path__ + "img/login-l.e1a425d6.png";